const initialState = {};
const state = {
  ...initialState,
  schools: [],
  schoolTypes: [],
  municipalities: [],
  rlvTypes: [],
  results: [],
  pagination: {
    currentPage: 1,
    totalItemCount: 0,
    pageCount: 0,
    count: 10,
  },
  filter: {
    locationSchoolId: null,
    schoolType: null,
    schoolName: null,
    isActive: true,
  },
};

export default state;
